export default __webpack_public_path__ + "static/media/marathi_finan_m.71fedfe0.wav";